import { render, staticRenderFns } from "./DashboardDialogDeleteContent.vue?vue&type=template&id=b939bdac&"
import script from "./DashboardDialogDeleteContent.vue?vue&type=script&lang=js&"
export * from "./DashboardDialogDeleteContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports